import { Component, Input } from '@angular/core';
import { AmplitudeService } from '../../services/amplitude.service';
import { WhatsappService } from '../../services/whatsapp.service';
import { LocaleValuesService } from '../../services/locale.values.service';

@Component({
  selector: 'icon-button-whatsapp',
  template: `
    <button [class.white]="colorClassWhite" (click)="openWhatsApp()" mat-icon-button color="primary" matTooltip="Ajuda">
      <mat-icon>contact_support</mat-icon>
    </button>
  `,
  standalone: false,
  styles: `
    .white {
      color: #ffffff;
    }
  `
})
export class IconButtonWhatsappComponent {

  @Input() colorClassWhite: boolean;
  @Input() automationWhatsappMsg: 'LOGIN';

  constructor(
    private localeValuesService: LocaleValuesService,
    private amplitudeService: AmplitudeService,
    private whatsappService: WhatsappService,
  ) {
  }

  openWhatsApp() {
    this.amplitudeService.sendEvent('contact_support_clicked', {
      stepName: location.pathname,
    });

    let msg = this.localeValuesService.getLocaleValue('icon.button.whatsapp.msg', [], false);

    if (this.automationWhatsappMsg === 'LOGIN') {
      msg = this.localeValuesService.getLocaleValue('patient.error.dialog.whatsapp.msg', [], false);
    }

    this.whatsappService.sendMessage(msg, { oId: true });
  }
}
